import { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  InputText,
  TEOLoader,
  Tag as ComponentTag,
  ProgressBar,
  FilterButton,
} from '@teo/components';
import { T } from '@/components/T';
import { Search, ChapterFilled, TimeFilled, Eye } from '@teo/components/icons';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { NavContext } from '@/components/NavContext';
import { Userwithorganisationwithidps } from '@/models';
import { useNavigate } from 'react-router-dom';
import { PaginationAnythingNew } from '@/components/DataTable/PaginationAnythingNew';
import { useGet } from '@/query/fetchHooks';
import { useMobile } from '@/util';
import MobileSubPageMenu from '@/components/HeaderMobile/MobileSubPageMenu';
import { format } from 'date-fns';
export interface Filter {
  label: string;
  value: string;
}

function LearnLearningPathsPage() {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filter), 250);
    return () => clearTimeout(t);
  }, [filter]);
  const [sort, setSort] = useState([{ id: 'createdAt', desc: true }]);
  const [loadCourses, setLoadCourses] = useState<any>(true);

  const [tab, setTab] = useState('active');

  const [filterStatus, setFilterStatus] = useState('');

  const { setLeftSidebarToggle, setSubPage } = useContext(NavContext);

  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const isMobile = useMobile();
  const authUser = auth?.user as Userwithorganisationwithidps;
  const coursePath = window.location.pathname;
  const [loadCounter, setLoadCounter] = useState(false);

  const [counterContent, setCounterContent] = useState({
    active: null,
    new: null,
    done: null,
    all: null,
  });

  useEffect(() => {
    setLeftSidebarToggle(true);
    return () => setLeftSidebarToggle(false);
  });

  useGet(`/mylpgroups`, {
    scope: 'nothidden',
    userId: authUser?.id,
    organisationId: authUser?.activeOrganisationId + ',OR,organisationId=null',
    onSuccess: (result: any) => {
      const active = result?.data?.filter(
        (el: any) =>
          (el?.status == 'active' || el?.status == 'pending') &&
          el?.lpStatus == 'active' &&
          !el?.isBlocked
      );
      const newC = result?.data?.filter(
        (el: any) =>
          (el?.status == 'pending' || el?.status == null) &&
          el?.lpStatus == 'active' &&
          !el?.isBlocked
      );
      const done = result?.data?.filter(
        (el: any) =>
          el?.status == 'done' ||
          el?.status == 'pendingcorrection' ||
          el?.status == 'ended' ||
          el?.lpStatus == 'disabled' ||
          el?.isBlocked
      );
      setCounterContent({
        active: active?.length,
        new: newC?.length,
        done: done?.length,
        all: result?.data?.length,
      });
      setLoadCounter(true);
    },
  });

  useEffect(() => {
    setSubPage(true);
    return () => setSubPage(false);
  }, []);

  function statusLpObj(str: string) {
    switch (str) {
      case 'active':
        return {
          value: 'status=active,OR,status=pending',
          lpStatus: 'lpStatus=active',
          isBlocked: 'isBlocked=false',
        };
      case 'new':
        return {
          value: 'status=pending,OR,status=null',
          lpStatus: 'lpStatus=active',
          isBlocked: 'isBlocked=false',
        };
      case 'done':
        return {
          value: 'status=done,OR,status=pendingcorrection,OR,status=ended',
          lpStatus: 'lpStatus=disabled',
          isBlocked: 'isBlocked=true',
        };
      default:
        return null;
    }
  }

  const createMarkup = (text: any) => {
    if (text) return { __html: text };
  };

  function convertToTime(number: number) {
    const hours = Math.floor(number / 3600);
    const minutes = Math.round((number / 3600 - hours) * 60);
    return (
      hours +
      `${t('pages.learn_index.hour')} ` +
      minutes +
      `${t('pages.learn_index.minute')} `
    );
  }

  useEffect(() => {
    if (tab != 'all') {
      const selectFilter = statusLpObj(tab);
      setFilterStatus(
        tab != 'done'
          ? `&${selectFilter?.isBlocked}&${selectFilter?.lpStatus}&${selectFilter?.value}`
          : `&${selectFilter?.isBlocked},OR,${selectFilter?.lpStatus},OR,${selectFilter?.value}`
      );
    } else {
      setFilterStatus('');
    }
  }, [tab]);

  return (
    <div className="mx-auto w-full max-w-[700px]">
      {isMobile ? (
        <MobileSubPageMenu
          title={'pages.lp_landing.learn_learningpaths_title'}
        />
      ) : (
        <div className="my-6">
          <h1 className="text-xl font-semibold text-black">
            <T>{t('pages.lp_landing.learn_learningpaths_title')}</T>
          </h1>
        </div>
      )}
      <>
        {/* <div className={`relative mb-8 sm:w-2/3 md:w-2/3`}>
          <InputText
            value={filter}
            onChange={(ev) => setFilter(ev.target.value)}
            Icon={Search}
            placeholder={t('search.learningpath')}
          />
        </div> */}
        <div className="mb-8 flex flex-col justify-between gap-2.5 md:flex-row md:gap-0 lg:flex-row lg:gap-0">
          <div className={`relative flex items-center`}>
            {loadCounter && (
              <div className={`relative flex flex-wrap items-center gap-2`}>
                <FilterButton
                  active={tab === 'active'}
                  onClick={() => {
                    if (tab != 'active') {
                      setTab('active');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.active')}
                    <span
                      className={`text-sm  ${
                        tab === 'active' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.active ? counterContent?.active : 0}
                    </span>
                  </p>
                </FilterButton>

                <FilterButton
                  active={tab === 'new'}
                  onClick={() => {
                    if (tab != 'new') {
                      setTab('new');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.new')}
                    <span
                      className={`text-sm  ${
                        tab === 'new' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.new ? counterContent?.new : 0}
                    </span>
                  </p>
                </FilterButton>

                <FilterButton
                  active={tab === 'done'}
                  onClick={() => {
                    if (tab != 'done') {
                      setTab('done');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.completed')}
                    <span
                      className={`text-sm  ${
                        tab === 'done' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.done ? counterContent?.done : 0}
                    </span>
                  </p>
                </FilterButton>
                <FilterButton
                  active={tab === 'all'}
                  onClick={() => {
                    if (tab != 'all') {
                      setTab('all');
                    }
                  }}
                >
                  <p className="flex items-center gap-1">
                    {t('pages.learn_courses.all')}
                    <span
                      className={`text-sm  ${
                        tab === 'all' ? 'text-secondary-02' : 'text-grey-05'
                      }`}
                    >
                      {counterContent?.all ? counterContent?.all : 0}
                    </span>
                  </p>
                </FilterButton>
              </div>
            )}
          </div>
        </div>
        {loadCourses && (
          <div className="mx-auto flex justify-center py-20 px-10">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[110px]"
            />
          </div>
        )}

        <PaginationAnythingNew
          className={`mt-3 flex w-full flex-col gap-10 ${
            loadCourses === true && ' hidden '
          }`}
          fetch={useGet.bind(null, '/mylpgroups', {
            scope: 'nothidden',
            userId: authUser?.id,
            organisationId:
              authUser?.activeOrganisationId +
              ',OR,organisationId=null' +
              filterStatus,
            onSuccess: (result: any) => {
              setLoadCourses(false);
            },
          })}
          empty={{
            template: 2,
            loadContent: loadCourses,
            text: t('pages.follow_learningpath.lp_list_empty'),
          }}
          defaultSort={sort}
          page={0}
          pageSize={10}
          filter={debouncedFilter}
          tab={tab}
          render={(lpgroup: any) => (
            <div
              className="group flex w-full cursor-pointer flex-col gap-6 sm:flex-row"
              onClick={() => navigate(`${coursePath}/${lpgroup?.lpgroupId}`)}
            >
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={
                    lpgroup?.lpgroupPicture ||
                    lpgroup?.lpPicture ||
                    '/assets/images/LearnPath.png'
                  }
                  alt={lpgroup?.lpgroupName || lpgroup?.lpName || ''}
                  className="h-[144px] w-full rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105 sm:w-[224px]"
                />
                <div className="absolute top-1 left-2 ">
                  <ComponentTag
                    title={
                      lpgroup?.isBlocked
                        ? t('status.blocked')
                        : lpgroup?.lpStatus == 'disabled'
                        ? t('status.disabled')
                        : t(
                            `status.${lpgroup?.status}`,
                            lpgroup?.lpStatus as string
                          )
                    }
                    variant={
                      lpgroup?.status == 'done' ||
                      lpgroup?.status == 'pendingcorrection' ||
                      lpgroup?.status == 'ended' ||
                      lpgroup?.lpStatus == 'disabled' ||
                      lpgroup?.isBlocked
                        ? 'error'
                        : 'primary'
                    }
                  />
                </div>
                <div className="absolute inset-0 h-full w-full rounded-lg transition-transform duration-500 group-hover:scale-105 group-hover:backdrop-blur-sm"></div>
                <span className="absolute inset-0 hidden items-center justify-center group-hover:flex">
                  <span className="rounded-md bg-grey-01 p-1 text-grey-09">
                    <Eye className="h-5 w-5 "></Eye>
                  </span>
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-2">
                <div className="flex flex-col gap-1">
                  <h3 className="text-base-semibold whitespace-break-spaces mb-2 !mb-0 break-keep text-left text-grey-08">
                    {lpgroup?.lpgroupName || lpgroup?.lpName || ''}
                  </h3>
                  {lpgroup?.lpEndDate && (
                    <p className="text-sm font-normal text-grey-05">
                      {`${t('pages.learn_index.last_open')}` +
                        format(new Date(lpgroup?.lpEndDate), 'dd/MM')}
                    </p>
                  )}
                </div>

                {lpgroup.lpProgress ? (
                  <div className="flex items-center">
                    <ProgressBar
                      max={100}
                      value={
                        lpgroup?.lpProgress
                          ? Math.round(lpgroup?.lpProgress * 100)
                          : 0
                      }
                      className={`r-progress-bar h-1 rounded-lg ${
                        lpgroup?.lpProgress * 100 > 99 && 'progress-bar__all'
                      }`}
                    />
                    <span className="ml-3 text-xs text-grey-06">
                      {lpgroup?.lpProgress
                        ? Math.round(lpgroup?.lpProgress * 100)
                        : 0}
                      &#37;
                    </span>
                  </div>
                ) : (
                  ''
                )}
                {(lpgroup?.lpgroupDescription || lpgroup?.lpDescription) && (
                  <div
                    className="break-words text-left text-sm font-normal text-grey-08 line-clamp-3"
                    dangerouslySetInnerHTML={createMarkup(
                      lpgroup?.lpgroupDescription ||
                        lpgroup?.lpDescription ||
                        ''
                    )}
                  />
                )}

                <div className="flex flex-row gap-4">
                  {lpgroup?.nrOfNodes > 0 && (
                    <div className="flex items-center">
                      <ChapterFilled className="h-4 w-4 text-grey-04" />
                      <p className="pl-1 text-sm text-grey-05">
                        {lpgroup?.nrOfNodes}
                      </p>
                    </div>
                  )}

                  {/*lpgroup?.lpEstimatedTime ? (
                    <div className="flex items-center">
                      <TimeFilled className="h-4 w-4 text-grey-04" />
                      <p className="pl-1 text-sm text-grey-05">
                        {convertToTime(Math.abs(lpgroup?.lpEstimatedTime))}
                      </p>
                    </div>
                  ) : (
                    ''
                  )$*/}
                </div>
              </div>
            </div>
          )}
        />
      </>
    </div>
  );
}

export default LearnLearningPathsPage;
